import compose from 'lodash/flowRight'
import type {ComponentType} from 'react'
import {connect} from 'react-redux'
import type {EntryPointProps} from 'react-relay'
import {usePreloadedQuery} from 'react-relay'

import withHook from '../../../hocs/withHook'
import {useSyncedQueryParam} from '../../../hooks/routes'
import type {State} from '../../../reducers/types'
import {UserProperties} from '../../../utils/userProperties'

import type {CleanupProjectPageUseIsReadOnlyQuery} from './__generated__/CleanupProjectPageUseIsReadOnlyQuery.graphql'
import CleanupProjectPage from './CleanupProjectPage'
import {UseIsReadonlyQuery} from './CleanupProjectPage.queries'
import {getIsAnyActionPerforming} from './CleanupProjectPage.selectors'
import type {OuterProps, OwnProps, StateProps} from './CleanupProjectPage.types'

const mapStateToProps = (state: State): StateProps => ({
  actionPerforming: getIsAnyActionPerforming(state),
})

export const CleanupProjectPageContainer: ComponentType<OwnProps> = compose(
  connect(mapStateToProps),
  withHook(() => {
    const [showSubprojectsParam, toggleSubprojects] = useSyncedQueryParam({
      param: 'showSubprojects',
      userProperty: UserProperties.CLEANUP_SHOW_SUBPROJECTS,
      values: ['true', 'false'],
      defaultValue: 'false',
    })
    return {
      showSubprojects: showSubprojectsParam === 'true',
      toggleSubprojects,
    }
  }),
)(CleanupProjectPage)

type Queries = {
  readOnlyProjects: CleanupProjectPageUseIsReadOnlyQuery
}
export default function CleanupProjectPageOuterContainer({
  queries,
  props,
}: EntryPointProps<Queries, {}, OuterProps, {}>) {
  const {projectsRest = null} = usePreloadedQuery(UseIsReadonlyQuery, queries.readOnlyProjects)
  return <CleanupProjectPageContainer {...props} readOnlyProjectsKey={projectsRest} />
}
export type CleanupProjectPageOuterContainerComponent = typeof CleanupProjectPageOuterContainer
